import {Component, OnInit} from '@angular/core';
import {MediaService} from '../../pages-services/media.service';
import {HttpClient} from '@angular/common/http';
import { ToasterService } from 'angular2-toaster';
import { TranslateService } from '@ngx-translate/core';
import { ChangesSubject, DataChangesObserver } from '@common-lib';

@Component({
    selector: 'app-media',
    templateUrl: './media.component.html',
    styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit {
    haveChanges = false;
    thumbnailsOnPage = 30;
    activeCollapse = '';
    changesCount = 0;
    changesSubject: ChangesSubject;
    assetsVersion: string;
    products = [{
        name: '',
        activePage: {},
        folders: [{
            images: [ ]
        }]
    }];
    basePath = '';
    isImageUploading = false;
    wichFolderUploading = '';
    wichFileDeleting = '';
    media = [];

    activeTab = 'products';

    constructor(
        private mediaService: MediaService,
        private http: HttpClient,
        private toasterService: ToasterService,
        private translationService: TranslateService,
        private datachanges: DataChangesObserver
    ) {

    }

    ngOnInit() {
        this.getList();
        console.log(this);
    }

    getList() {
        this.mediaService.getList().subscribe(response => {
            this.basePath = response.result.basePath;
            this.products = response.result.assets.map((product) => {
                return {
                    ...product,
                    activePage: product.folders.reduce((acc, folder) => {
                        acc[folder.name] = 1;
                        return acc;
                    }, {})
                }
            });
            this.assetsVersion = response.result.assetsVersion;
            if (response.result.media.length) {
                this.media = this.createChangesObservation(response.result.media);
            }
        });
    }

    fileUpload(files: FileList, product, folder) {
        this.wichFolderUploading = product + folder;
        const path = `assets/${product}/${folder}`;
        const fileToUpload = files.item(0);

        this.mediaService.uploadFile(fileToUpload, path).subscribe(
            async response => {
                // this.products.forEach(p => {
                //     if (p.name === product) {
                //         p.folders.forEach((f: any) => {
                //             if (f.name === folder) {
                //                 f.files.push({
                //                     path: fileToUpload.name,
                //                     v: (new Date()).getTime()
                //                 });
                //             }
                //         });
                //     }
                // });
                this.wichFolderUploading = '';
                this.toasterService.pop(
                    'success',
                    '',
                    await this.translationService.get('webpanel.media.file_uploaded_successfully').toPromise()
                );

                this.getList();
            },
            async error => {
                this.wichFolderUploading = '';
                console.log('error');
                this.toasterService.pop(
                    'error',
                    await this.translationService.get('webpanel.media.file_upload_error').toPromise(),
                    error.message,
                );
            }
        );
    }

    imageUpload(files: FileList) {
        this.isImageUploading = true;
        const path = `images`;
        const fileToUpload = files.item(0);

        this.mediaService.uploadFile(fileToUpload, path).subscribe(
            async response => {
                this.isImageUploading = false;
                this.toasterService.pop(
                    'success',
                    '',
                    await this.translationService.get('webpanel.media.file_uploaded_successfully').toPromise()
                );

                this.getList();
            },
            async error => {
                this.isImageUploading = false;
                console.log('error');
                this.toasterService.pop(
                    'error',
                    '',
                    await this.translationService.get('webpanel.media.file_upload_error').toPromise()
                );
            }
        );
    }

    deleteFile(product, folder, image) {
        this.wichFileDeleting = product + folder + image;
        const pathToImage = `assets/${product}/${folder}/${image}`;
        this.mediaService.deleteFile(pathToImage).subscribe(
            async response => {

                this.products.forEach(p => {
                    if (p.name === product) {
                        p.folders.forEach((f: any) => {
                            if (f.name === folder) {
                                // f.files.filter() = f.files.filter();
                            }
                        });
                    }
                });

                this.wichFileDeleting = '';
                this.toasterService.pop(
                    'success',
                    '',
                    await this.translationService.get('webpanel.media.file_deleted_successfully').toPromise()
                );

                this.getList();
            },
            async error => {
                this.wichFileDeleting = '';
                this.toasterService.pop(
                    'error',
                    '',
                    await this.translationService.get('webpanel.media.file_delete_error').toPromise()
                );
            }
        );
    }

    deleteImage(image) {
        const  pathToImage = `images/${image}`;
        this.mediaService.deleteFile(pathToImage).subscribe(
            async response => {
                this.wichFileDeleting = '';
                this.toasterService.pop(
                    'success',
                    '',
                    await this.translationService.get('webpanel.media.file_deleted_successfully').toPromise()
                );

                this.getList();

            },
            async error => {
                this.toasterService.pop(
                    'error',
                    '',
                    await this.translationService.get('webpanel.media.file_delete_error').toPromise()
                );
            }
        );
    }

    deleteVideo(id) {
        this.mediaService.deleteVideo(id.toString()).subscribe(
            async response => {
                this.wichFileDeleting = '';

                this.toasterService.pop(
                    'success',
                    '',
                    await this.translationService.get('webpanel.media.file_deleted_successfully').toPromise()
                );

                this.getList();
            },
            async error => {
                this.toasterService.pop(
                    'error',
                    '',
                    await this.translationService.get('webpanel.media.file_delete_error').toPromise()
                );
            }
        );
    }

    addVideo() {
        this.media.forEach(mediaItem => {
            if (mediaItem.name === 'video') {
                mediaItem.files.push({
                    path: '',
                    title: '',
                });
            }
        });
        console.log(this.media);
    }

    getVideoThumbnail(link) {
        const youtubeId = this.getYoutubeId(link);
        return `https://img.youtube.com/vi/${youtubeId}/0.jpg`;
    }

    getYoutubeId(link) {
        if ((link && !link.length) || !link.includes('youtube')) {
            return '';
        }

        let videoId = link.split('v=')[1];
        const ampersandPosition = videoId.indexOf('&');
        if (ampersandPosition !== -1) {
            videoId = videoId.substring(0, ampersandPosition);
        }
        return videoId;
    }

    saveSettingsData () {
        this.mediaService.updateMediaInfo({ media: this.media }).subscribe(res => {
            console.log(res);
            this.getList();
        });
    }

    cancelChanges () {
        this.getList();
    }

    private createChangesObservation(settings) {
        this.changesCount = 0;
        this.haveChanges = false;
        const subject = this.datachanges.observe(settings);
        this.changesSubject = subject;
        subject.onChanges.subscribe((event) => {
            this.changesCount = event.subject.changesCount;
            this.haveChanges = this.changesCount > 0;
        });
        return subject.getProxy();
    }

    toggleAccordion(productName) {
        if (this.activeCollapse === productName) {
            this.activeCollapse = '';
        } else {
            this.activeCollapse = productName;
        }
    }

    getThumbnails(currentPage, thumbnails = []) {
        const startTableData = (this.thumbnailsOnPage * currentPage) - this.thumbnailsOnPage;
        const endTableData = (this.thumbnailsOnPage * currentPage);

        return thumbnails.slice(startTableData, endTableData)
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/media/media.component.ts